import { cloneElement, forwardRef, memo, useEffect, useImperativeHandle, useRef } from 'react';

const Resizeable = forwardRef(({ onResize, children, skipFirstMount = false }, ref) => {
  const isSkiped = useRef(skipFirstMount);
  const resizeRef = useRef(null);
  useImperativeHandle(ref, () => resizeRef.current);

  useEffect(() => {
    const resizeObserver = new ResizeObserver((entries) => {
      const { width, height } = entries[0].contentRect;
      if (isSkiped.current) {
        isSkiped.current = false;
      } else {
        onResize(width, height);
      }
    });
    resizeObserver.observe(resizeRef.current);

    return () => {
      resizeObserver.disconnect();
    };
  }, [onResize]);

  return cloneElement(children, { ref: resizeRef });
});

export default memo(Resizeable);
